import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

import AccountManager from './account-manager';
import Broadcast from './broadcast';
import Broadcasts from './broadcasts';
import Customers from './customers';
import Collections from './collections';
import Donations from './donations';
import Tags from './tags';
import User from './user';
import Video from './video';
import Videos from './videos';
import Streams from './streams';
import Developer from './developer';
import Play from './play';
import Transactions from './transactions';
import Upload from './upload';
import Products from './products';
import Price from './price';
import Oauth from './oauth';
import Plan from './plan';
import Events from './events';
import Chat from './chat';
import Theme from './theme';
import Giveaway from './giveaway';
import Notifications from './notifications';
import Player from './player';
import Forms from './forms';

Vue.use(Vuex);

const persist = new VuexPersist({
  key: 'streamify',
  reducer: state => ({
    User: {
      token: state.User.token,
    },
    Broadcast: {
      streamingDevice: state.Broadcast.streamingDevice,
      newControlCenter: state.Broadcast.newControlCenter,
    },
    Chat: {
      chatname: state.Chat.chatname,
      sessions: state.Chat.sessions,
    },
    Theme: {
      sidebarCollapsed: state.Theme.sidebarCollapsed,
      darkmode: state.Theme.darkmode,
      liveshoppingMessageSeen: state.Theme.liveshoppingMessageSeen,
      ppvMessageSeen: state.Theme.ppvMessageSeen,
      onboardingDone: state.Theme.onboardingDone,
    },
  }),
});

export default new Vuex.Store({
  modules: {
    AccountManager,
    Broadcast,
    Broadcasts,
    Customers,
    Collections,
    Donations,
    Developer,
    Events,
    Tags,
    User,
    Video,
    Streams,
    Play,
    Videos,
    Transactions,
    Upload,
    Products,
    Price,
    Oauth,
    Plan,
    Chat,
    Theme,
    Giveaway,
    Notifications,
    Player,
    Forms,
  },
  plugins: [persist.plugin],
});
